<template lang="pug">
  .select-all(
    @click="selectToggle"
  ) {{ selectText }}
</template>
<script>
import errorsMixin from '@/mixins/errors.mixin'
export default {
  props: {
    activeItemsCount: Number,
    itemsToSelectCount: Number,
  },
  mixins: [errorsMixin],
  computed: {
    allSelected() {
      return this.itemsToSelectCount === this.activeItemsCount;
    },
    selectText() {
      return this.allSelected ? `Unselect all` : `Select up to 1000`
    }
  },
  data: () => ({
    maxAbleToSelect: 1000,
  }),
  methods: {
    async selectToggle() {
      if (this.allSelected) {
        this.$emit('change', {clear: true})
      } else {
        if (this.itemsToSelectCount > this.maxAbleToSelect) {
          this.showErrorModal(`Cannot select more than ${this.maxAbleToSelect}`)
          return
        }
        this.$emit('change', {clear: false})
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.select-all {
  display: flex;
  white-space: nowrap;
  align-items: center;
  color: $primary-color;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
}
</style>